import { render, staticRenderFns } from "./RatingsListTable.vue?vue&type=template&id=1a905eb0&scoped=true"
import script from "./RatingsListTable.vue?vue&type=script&lang=js"
export * from "./RatingsListTable.vue?vue&type=script&lang=js"
import style0 from "./RatingsListTable.vue?vue&type=style&index=0&id=1a905eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a905eb0",
  null
  
)

export default component.exports